export default __webpack_public_path__ + "static/group-tour-booking-system-deecb5491725bd3cddea66217a502602.png";